<template>
  <!-- 修改密码 -->

  <!-- 右侧内容 -->
  <div class="MeetingAdministration-rightContent fr">
    <!-- 头部 -->
    <div class="MeetingAdministration-rightContent-top">
      <h4 class="fl">
        <router-link
          to="account"
          style="color:#676c71"
        >帐号设置/修改密码</router-link>
      </h4>
    </div>
    <!-- 中间 -->
    <div class="MeetingAdministration-rightContent-center">
      <!-- 中心内容 -->
      <div class="center-content" style="position: relative;z-index: 1">
        <el-form
          :label-position="labelPosition"
          label-width="70px"
          :model="formLabel"
          :rules="rules"
          ref="formLabel"
        >
          <el-form-item
            label="原密码:"
            prop="oldpassword"
          >
            <el-input
              type="password"
              placeholder="请输入原密码"
              v-model="formLabel.oldpassword"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="新密码:"
            prop="newpassword"
          >
            <el-input
              v-model="formLabel.newpassword"
              type="password"
              placeholder="请输入新密码"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="确认密码:"
            prop="repassword"
          >
            <el-input
              v-model="formLabel.repassword"
              type="password"
              placeholder="请确认密码"
            ></el-input>
          </el-form-item>
        </el-form>
        <!-- 下面的按钮 -->
        <el-button
          class="center-draft fl"
          @click.native="ChangePassword"
        > 确定 </el-button>
      </div>

    </div>

  </div>

</template>

<script>
import { updatePassword } from '@/api/institutional/user'
import { encrypt } from "@/utils/rsaEncrypt";
export default {
  name: 'ModifyPassword',
  data () {
    //表单验证——自定义验证密码
    var validPassword = (rule, value, callback) => {
      const reg = /(?!^(\d+|[a-zA-Z]+|[~!@#$%^&*()_.]+)$)^[\w~!@#$%^&*()_.]{6,18}$/;
      if (reg.test(value)) {
        callback()
      } else {
        callback(new Error('密码以字母开头 长度在6~18之间 包含字母、数字、以及特殊符号任意两种'))
      }
    };
    //自定义验证确认密码
    var validatePass2 = (rule, value, callback) => {
      console.log(value,'lao',this.formLabel.newpassword,'xin')
      if (value === '') {
        callback(new Error('请再次输入密码!'));
      } else if (value !== this.formLabel.newpassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      labelPosition: 'left',
      formLabel: {
        oldpassword: '',
        newpassword: '',
        repassword: ''
      },
      rules: {
        oldpassword: [
          { required: true, message: '请输入原密码！', trigger: 'blur' },
        ],
        newpassword: [
          { required: true, message: "请输入新密码！", trigger: 'blur' },
          { validator: validPassword, trigger: "blur" },
        ],
        repassword: [
          { required: true, message: "请再次输入密码！", trigger: 'blur' },
          { validator: validatePass2, trigger: "blur" },
        ]
      }
    }
  },
  methods: {
    ChangePassword () {
      const password = encrypt(this.formLabel.oldpassword);
      const newpassword = encrypt(this.formLabel.newpassword);
      this.$confirm("确认修改密码, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        updatePassword(password, newpassword).then(res => {
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "修改密码成功,请重新登录！"
            });
            this.$router.push({
              path: '/instructionlogin'
            })
          } else {
            this.$notify({
              type: "error",
              message: "修改密码失败！"
            });
          }
        })
      })
    }

  }

}
</script>

<style scoped>
/* 右侧内容 */
.MeetingAdministration-rightContent {
  height: 1000px;
}
.MeetingAdministration-rightContent-top {
  position: relative;
  margin-bottom: 10px;
  width: 992px;
  height: 34px;
}
.MeetingAdministration-rightContent-top::after {
  position: absolute;
  left: 0;
  bottom: 0;
  content: "";
  width: 992px;
  height: 0px;
  opacity: 1;
  border: 1px solid #e5e5e5;
}
/* 会议管理 */
.MeetingAdministration-rightContent-top h4 {
  margin-top: 5px;
  width: 137px;
  height: 22px;
  font-size: 16px;
  font-weight: 600;
  color: #676c71;
}

/* 中心内容的上部 */
.center-top {
  width: 992px;
  height: 26px;
}
.center-top .center-top-text {
  width: 64px;
  height: 22px;
  font-size: 16px;
  font-weight: 600;
  color: #000;
}
/* 中心内容 */
/* 左边的label框 */
.center-content >>> .el-form-item__label {
  padding-right: 0px;
  width: 75px !important;
}
/* 包着label和input框的盒子 */
.center-content >>> .el-form-item__content {
  margin-bottom: 8px;
  margin-left: 75px !important;
  width: 360px;
  height: 30px;
}
/* input框 */
.center-content >>> .el-input--small {
  outline: 0;
}
.center-content >>> .el-form-item__error {
  padding-top: 10px;
  width: 360px;
}
.center-content >>> .el-input__inner {
  padding-left: 5px;
  width: 360px;
  height: 28px;
  line-height: 28px;
  font-size: 14px;
  color: #333;
  border: 1px solid #e5e5e5;
  /* -webkit-text-security: disc; */
}
/* 两个框的距离 */
.center-content >>> .el-form-item--small.el-form-item {
  margin-bottom: 10px;
}
/* 下面的按钮 */
.center-draft {
  margin-top: 11px;
  width: 83px;
  height: 28px;
  text-align: center;
  background: #eb5139;
  border-radius: 4px;
  color: #fff;
  border: 0;
}
</style>
